import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Button, Popup } from 'semantic-ui-react'
import {toggleModal} from "../../Actions/ToggleModal";
import {modifyKeysPK} from "../../Actions/ModifyKeysPK";
import API_Root from "../../Constants/API_Root";
import {modifyFileInformation} from "../../Actions/ModifyFileInformation";
import {gunaldiStyles} from "../../SharedComponents/GunaldiDesignStyles";

class RegenerateKeysButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keysPopup: false,
            regenerating: false
        }

        this.regenerateKeys = this.regenerateKeys.bind(this);

        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);

    }

    updateKeyPairs = (newKeyPair) => {
        this.props.updateKeyPairs(newKeyPair)
    }

    handleClose(){
        this.setState({
            keysPopup: false
        })
    }

    handleOpen(){
        this.setState({
            keysPopup: true
        })
    }

    regenerateKeys(e){
        this.setState({
            regenerating: true
        });

        const resetStates = () => this.setState({ regenerating: false, keysPopup: false });

        fetch(API_Root + "api/regenerate-additional-key-pairs-for-api-spreadsheets/", {
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
            },
            body: JSON.stringify({
                email: localStorage.getItem("email"),
                token: localStorage.getItem("token"),
                keysPK: this.props.keysPK
            })
        }).then(res => {

            if (res.status === 201){
                res.json().then((data) => {
                    this.updateKeyPairs(data)

                    resetStates()
                }).catch((err) => {
                    resetStates()
                })
            }
            else{
                resetStates()
            }
        }).catch(err => resetStates())
    }

    render() {
        return (
            <Popup trigger={<div><Button style={gunaldiStyles.btnGreen} content={"Get New Key Pair " + this.props.pairNum} icon="refresh" /></div>}
                   content={
                       <div style={{textAlign: 'center'}}>
                           <h5 className="thinHeading">Are you sure you want to regenerate your keys?</h5>
                           <Button color='green' content='No' onClick={this.handleClose} />
                           <Button color='red' content='Regenerate' onClick={this.regenerateKeys} loading={this.state.regenerating} />
                       </div>
                   }
                   on='click'
                   open={this.state.keysPopup}
                   onClose={this.handleClose}
                   onOpen={this.handleOpen}
                   position='top'
            />
        )
    }
}

const mapStateToProps = (state) => ({
    fileInformation: state.mainState.fileInformation
})

const mapActionsToProps = {
    toggleModal: toggleModal,
    modifyKeysPK: modifyKeysPK,
    modifyFileInformation: modifyFileInformation
}

export default connect(mapStateToProps, mapActionsToProps)(RegenerateKeysButton)